import React, {memo} from "react"
import Grid from "@mui/material/Grid";
import {useTranslation} from "react-i18next";

import FormSection from "../../../components/FormSection";
import useDialog from "../../../components/useDialog";
import Model1Select from "./Model1Select";

import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import L1InfoDialog from "./L1InfoDialog";
import {formikPropertyEqual} from "./index";


export const observedAvalanchesColumns = ['l1', 'l2', 'l3', 'l4', 'l5', 'l6'];


const ObservedAvalanches = memo(({formik, model1Registry, warnings, inputDisabled, visibleColumns}) => {
    const {t} = useTranslation(['models1']);

    const l1Registry = model1Registry.data?.l1 ?? [];
    const l2Registry = model1Registry.data?.l2 ?? [];
    const l3Registry = model1Registry.data?.l3 ?? [];
    const l4Registry = model1Registry.data?.l4 ?? [];
    const l5Registry = model1Registry.data?.l5 ?? [];
    const l6Registry = model1Registry.data?.l6 ?? [];

    const l1Dialog = useDialog();

    const handleL1Change = async (e) => {
        if(e.target.value === '/' || e.target.value === '0') {
            // set all fields L1,...,L6 equal to the new value
            await formik.setFieldValue('l1', e.target.value);
            await formik.setFieldValue('l2', e.target.value);
            await formik.setFieldValue('l3', e.target.value);
            await formik.setFieldValue('l4', e.target.value);
            await formik.setFieldValue('l5', e.target.value);
        }
        else{
            await formik.handleChange(e);
        }
    }

    const isVisible = (column) => (!visibleColumns || visibleColumns?.[column]);

    const disableL2L5 = formik.values.l1 === '/' || formik.values.l1 === '0';

    return <FormSection title={t('model1Form.observedAvalanches')}>
        <Grid container rowSpacing={3} columnSpacing={4}>
            {
                isVisible("l1") &&
                <Grid item xs={12} sx={{display: "flex", flexWrap: "nowrap", alignItems: "center"}}>
                    <Model1Select name="l1" formik={formik} registry={l1Registry} warnings={warnings}
                                  onChange={handleL1Change} disabled={inputDisabled}/>
                    <IconButton onClick={l1Dialog.open}>
                        <Icon fontSize="small">info</Icon>
                    </IconButton>
                </Grid>
            }
            {
                isVisible("l2") &&
                <Grid item xs={12}>
                    <Model1Select name="l2" formik={formik} registry={l2Registry} warnings={warnings}
                                  disabled={inputDisabled || disableL2L5}/>
                </Grid>
            }
            {
                isVisible("l3") &&
                <Grid item xs={12}>
                    <Model1Select name="l3" formik={formik} registry={l3Registry} warnings={warnings}
                                  disabled={inputDisabled || disableL2L5}/>
                </Grid>
            }
            {
                isVisible("l4") &&
                <Grid item xs={12}>
                    <Model1Select name="l4" formik={formik} registry={l4Registry} warnings={warnings}
                                  disabled={inputDisabled || disableL2L5}/>
                </Grid>
            }
            {
                isVisible("l5") &&
                <Grid item xs={12}>
                    <Model1Select name="l5" formik={formik} registry={l5Registry} warnings={warnings}
                                  disabled={inputDisabled || disableL2L5}/>
                </Grid>
            }
            {
                isVisible("l6") &&
                <Grid item xs={12}>
                    <Model1Select name="l6" formik={formik} registry={l6Registry} warnings={warnings}
                                  disabled={inputDisabled}/>
                </Grid>
            }
        </Grid>

        {
            l1Dialog.isOpen && <L1InfoDialog l1Registry={l1Registry} dialog={l1Dialog}/>
        }
    </FormSection>
}, (prevProps, nextProps) => formikPropertyEqual(prevProps, nextProps, observedAvalanchesColumns));

export default ObservedAvalanches;